import { Injectable, Inject } from '@angular/core';

/**
 * Translate service.
 *
 * @todo TranslateMenu function.
 * @todo Not all methods are mapped to the correct helpers yet. When not sure,
 *  it's always mapped the the default `getLabel()` so it won't break translate,
 *  but the formatting may be wrong (uppercase, lowercase, etc).
 */
@Injectable({
  providedIn: 'root'
})
export class TranslateService {

  /** Legacy Auth reference. */
  private _sgAuthService: any;

  /** Translate Helpers. */
  private _sgTranslateHelpers: any;


  /** Constructor. */
  constructor(
    @Inject('sgAuth') sgAuthService: any,
    @Inject('sgLABELS_CONSTANT') sgLABELS_CONSTANT: any,
    @Inject('sgTranslateHelpers') sgTranslateHelpers: any,
  ) {
    this._sgAuthService = sgAuthService;
    this._sgTranslateHelpers = new sgTranslateHelpers({
      labels: sgLABELS_CONSTANT,
      languageFn: this._sgAuthService.getCurrentUserLanguage
    });
  }

  /**
   * Get label.
   *
   * @param label Label translate string.
   * @returns Translated label.
   */
  public get(label: string): string {
    return this._sgTranslateHelpers.getLabel(label);
  }

  /**
   * Get label and transform first character to uppercase.
   *
   * @param label Label translate string.
   * @returns Translated label with first character transformed to uppercase.
   */
  public getCapFirstLetter(label: string): string {
    return this._sgTranslateHelpers.getLabelCapFirstLetter(label);
  }

  /**
   * Get label and transform to lowercase.
   *
   * @param label Label translate string.
   * @returns Translated label transformed to lowercase.
   */
  public getLowerCase(label: string): string {
    return this._sgTranslateHelpers.getLabelLowerCase(label);
  }

  /**
   * Get label placeholder.
   *
   * @todo Check with actual text with placeholder.
   *
   * @param label Label translate string.
   * @returns Translated label.
   */
  public getPlaceholder(label: string): string {
    return this._sgTranslateHelpers.getLabelPlaceholder(label);
  }

  /**
   * Get label placeholder and transform to lowercase.
   *
   * @todo Check with actual text with placeholder.
   *
   * @param label Label translate string.
   * @returns Translated label transformed to lowercase.
   */
  public getPlaceholderLowerCase(label: string): string {
    return this._sgTranslateHelpers.getLabelPlaceholderLowerCase(label);
  }

  /**
   * Get label text with placeholder.
   *
   * @todo Check with actual text with placeholder.
   *
   * @param label Label translate string.
   * @returns Translated label text.
   */
  public getTextWithPlaceholder(label: string): string {
    return this._sgTranslateHelpers.getLabelTextWithPlaceholder(label);
  }

  /**
   * Get label and transform to uppercase.
   *
   * @param label Label translate string.
   * @returns Translated label transformed to uppercase.
   */
  public getUpperCase(label: string): string {
    return this._sgTranslateHelpers.getLabelUpperCase(label);
  }

  /**
   * Get plural label.
   *
   * @param label Label translate string.
   * @returns Pluralized label.
   */
  public getPlural(label: string): string {
    return this._sgTranslateHelpers.getPlural(label);
  }

  /**
   * Get plural label and transform first character to uppercase.
   *
   * @param label Label translate string.
   * @returns Pluralized label with first character transformed to uppercase.
   */
  public getPluralCapFirstLetter(label: string): string {
    return this._sgTranslateHelpers.getPluralCapFirstLetter(label);
  }

  /**
   * Get plural label and transform to lowercase.
   *
   * @param label Label translate string.
   * @returns Pluralized label transformed to lowercase.
   */
  public getPluralLowerCase(label: string): string {
    return this._sgTranslateHelpers.getPluralLowerCase(label);
  }

  /**
   * Get plural label and transform to uppercase.
   *
   * @param label Label translate string.
   * @returns Pluralized label transformed to uppercase.
   */
  public getPluralUpperCase(label: string): string {
    return this._sgTranslateHelpers.getPluralUpperCase(label);
  }

}
